export const FETCH_SECURITY_SETTINGS_REQUEST =
  'securitySettings/FETCH_SECURITY_SETTINGS_REQUEST'
export const FETCH_SECURITY_SETTINGS_SUCCESS =
  'securitySettings/FETCH_SECURITY_SETTINGS_SUCCESS'
export const FETCH_SECURITY_SETTINGS_FAILURE =
  'securitySettings/FETCH_SECURITY_SETTINGS_FAILURE'

export const UPDATE_SECURITY_SETTINGS_REQUEST =
  'securitySettings/UPDATE_SECURITY_SETTINGS_REQUEST'
export const UPDATE_SECURITY_SETTINGS_SUCCESS =
  'securitySettings/UPDATE_SECURITY_SETTINGS_SUCCESS'
export const UPDATE_SECURITY_SETTINGS_FAILURE =
  'securitySettings/UPDATE_SECURITY_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'securitySettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'securitySettings/SET_DEFAULT_DATA'
